import { useContext, useRef } from 'react';

import { MessageContext } from '@/helpers/MessageProvider';
import { deepCopy } from '@/utils/ObjectUtils';

const useMavLinkCommandHandler = (robot) => {
  const { publishCommand } = useContext(MessageContext);
  const intervals = useRef([]);

  const addInterval = (command, payloads, interval) => {
    const id = setInterval(() => {
      // payloads가 함수면 실행한 결과를 사용, 아니면 고정값 사용
      const actualPayloads = typeof payloads === 'function' ? payloads() : payloads.map((payload) => deepCopy(payload));

      publishCommand(robot, command, actualPayloads);
    }, interval);
    intervals.current.push(id);
  };

  const clearIntervals = () => {
    intervals.current.forEach(clearInterval);
  };

  return { addInterval, clearIntervals };
};

export default useMavLinkCommandHandler;
